module.exports = __webpack_public_path__ + "static/media/PATS_6-1920w.dabcc3e5.webp";